import GenericLangValue from "./GenericLangValue";
import TypeValue from "./TypeValue";
import GenericTextValue from "./GenericTextValue";
import AmountSizeUnit from "./AmountSizeUnit";
import GenericIdValueList from "./GenericIdValueList";
import {keys} from "../config/nameSpacesKeys";
import {assetKeys} from "../config/constants";

export default class ModelDistribution {
  constructor(name, initialValue, namespace, titleNameSpace,
      distributionMethodNameSpace, accessLevelNameSpace,
      amountOfActiveParametersNameSpace, tokensPerParameterNameSpace, accessLocationNameSpace,
      formatNameSpace, sizeNameSpace) {
    this.namespace = namespace;
    this.name = name;
    this.accessLocationNameSpace = accessLocationNameSpace;
    this.amountOfActiveParametersNameSpace = amountOfActiveParametersNameSpace;
    this.tokensPerParameterNameSpace = tokensPerParameterNameSpace;
    this.titleNameSpace = titleNameSpace;
    this.distributionMethodNameSpace = distributionMethodNameSpace;
    this.accessLevelNameSpace = accessLevelNameSpace;
    this.formatNameSpace = formatNameSpace;
    this.sizeNameSpace = sizeNameSpace;
    this.accessLocation = new TypeValue("accessLocation", null, accessLocationNameSpace, keys.uriType);
    this.title=new GenericLangValue(name="title", null, keys.title);
    this.distributionMethod=new GenericLangValue(name="distributionMethod", null, distributionMethodNameSpace);
    this.accessLevel=new GenericLangValue(name="accessLevel", null, accessLevelNameSpace);
    this.format = new GenericIdValueList("format", null, formatNameSpace);
    this.amountOfActiveParameters=new GenericTextValue("amountOfActiveParameters", null, amountOfActiveParametersNameSpace);
    this.tokensPerParameter=new GenericTextValue("tokensPerParameter", null, tokensPerParameterNameSpace);

    this.size = [];
    if (initialValue) {
      this.parseInputJSON(initialValue);
    } else {
      this.createEmptyAmountSizeUnitObj();
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getMediaTypeObj() {
    return this.mediaType;
  }
  setMediaTypeObj(mediaTypeObj) {
    this.mediaType = mediaTypeObj;
  }

  getFormatObj() {
    return this.format;
  }

  setFormatObj(formatObj) {
    this.format = formatObj;
  }

  getAmountOfActiveParametersObj() {
    return this.amountOfActiveParameters;
  }

  setAmountOfActiveParametersObj(amountObj) {
    this.amountOfActiveParameters=amountObj;
  }


  getTokensPerParameterObj() {
    return this.tokensPerParameter;
  }

  setTokensPerParameterObj(amountObj) {
    this.tokensPerParameter=amountObj;
  }

  createEmptyAmountSizeUnitObj() {
    const amountSizeUnit = new AmountSizeUnit("size", null, this.sizeNameSpace, keys.amount, keys.sizeUnit);
    this.size.push(amountSizeUnit);
  }

  createAmountSizeUnitObj(obj) {
    const amountSizeUnit = new AmountSizeUnit("size", null, this.sizeNameSpace, keys.amount, keys.sizeUnit);
    amountSizeUnit.parseInputJSON(obj);
    this.size.push(amountSizeUnit);
  }

  removeAmountSizeUnitObj(obj, index) {
    if (index < 0 || index >= this.size.length) {
      return false;
    }
    this.size.splice(index, 1);
  }

  setSize(inputObj) {
    // console.log(inputObj, this.sizeNameSpace);
    const sizeObj = inputObj[this.sizeNameSpace];
    if (Array.isArray(sizeObj)) {
      for (const entry of Object.entries(sizeObj)) {
        const value = entry[1];
        this.createAmountSizeUnitObj(value);
      }
    } else {
      this.createAmountSizeUnitObj(sizeObj);
    }
  }

  setValueObj(obj) {
    // console.log(obj);
    this.accessLocation.parseInputJSON(obj);
    this.title.parseInputJSON(obj);
    this.distributionMethod.parseInputJSON(obj);
    this.accessLevel.parseInputJSON(obj);
    this.amountOfActiveParameters.parseInputJSON(obj);
    this.tokensPerParameter.parseInputJSON(obj);
    this.format.parseInputJSON(obj);
    this.setSize(obj);
  }

  parseInputJSON(inputJSON) {
    // console.log(inputJSON, this.namespace);
    const obj = inputJSON[this.namespace];
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        this.setValueObj(value);
      }
    } else {
      this.setValueObj(obj);
    }
  }

  getExpandedFormatValue() {
    const obj = {};
    const accessLocationExpanded = this.accessLocation.getExpandedFormatValue();
    const titleExpanded = this.title.getExpandedFormatValue();
    const distributionMethodExpanded = this.distributionMethod.getExpandedFormatValue();
    const accessLevelExpanded = this.accessLevel.getExpandedFormatValue();
    const amountOfActiveParametersExpanded = this.amountOfActiveParameters.getExpandedFormatValue(true);
    const formatExpanded = this.format.getExpandedFormatValue();
    const tokensPerParameterExpanded = this.tokensPerParameter.getExpandedFormatValue(true);
    const sizeExpanded = [];
    for (let index = 0; index < this.size.length; index++) {
      const sizeItem = this.size[index];
      sizeExpanded.push(sizeItem.getExpandedFormatValue());
    }
    obj[assetKeys.type] = [`${keys.ModelDistributionType}`];
    obj[this.accessLocation.getNameSpace()] = accessLocationExpanded;
    obj[this.format.getNameSpace()] = formatExpanded;
    obj[this.title.getNameSpace()] = titleExpanded;
    obj[this.distributionMethod.getNameSpace()] = distributionMethodExpanded;
    obj[this.accessLevel.getNameSpace()] = accessLevelExpanded;
    obj[this.amountOfActiveParameters.getNameSpace()] = amountOfActiveParametersExpanded;
    obj[this.tokensPerParameter.getNameSpace()] = tokensPerParameterExpanded;
    obj[this.sizeNameSpace] = sizeExpanded;
    return obj;
  }

  isEmpty() {
    const condition1 = this.amountOfActiveParameters.isEmpty() && this.tokensPerParameter.isEmpty() &&
        this.format.isEmpty() && this.title.isEmpty() && this.distributionMethod.isEmpty() &&
        this.accessLevel.isEmpty() && this.accessLocation.isEmpty();
    let condition2 = true;
    for (let index = 0; index < this.size.length; index++) {
      const sizeItem = this.size[index];
      condition2 = condition2 && sizeItem.isEmpty();
    }
    return condition1 && condition2;
  }
}
